<ng-container *ngFor="let item of navigation">
  <kiss-navigation-group *ngIf="item.type === 'group'" [item]="item"></kiss-navigation-group>

  <kiss-navigation-item *ngIf="item.type === 'item'" [item]="item"></kiss-navigation-item>

  <kiss-navigation-list *ngIf="item.type === 'list'" [item]="item"></kiss-navigation-list>
</ng-container>
